import React from "react";
import almas_terms from "../pages/terms/almas_terms";

const TermsAndConditions = () => {
    const site = process.env.REACT_APP_CLIENT_NAME;
    let terms;
    switch (site) {
        case "almas":
            terms = almas_terms;
            break;
        default:
            terms = "Terms and conditions not available";
    }

    return (
        <p dangerouslySetInnerHTML={{__html:terms}}>
        </p>
    )
}
export default TermsAndConditions;